import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './providers/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'inicio',
    loadChildren: () => import('./pages/inicio/inicio.module').then( m => m.InicioPageModule)
  },
  {
    path: 'agendarevento',
    loadChildren: () => import('./pages/agendarevento/agendarevento.module').then( m => m.AgendareventoPageModule)
  },
  {
    path: 'emitirlicencia',
    loadChildren: () => import('./pages/emitirlicencia/emitirlicencia.module').then( m => m.EmitirlicenciaPageModule)
  },
  {
    path: 'licencias',
    loadChildren: () => import('./pages/licencias/licencias.module').then( m => m.LicenciasPageModule)
  },
  {
    path: 'listaeventos',
    loadChildren: () => import('./pages/listaeventos/listaeventos.module').then( m => m.ListaeventosPageModule)
  },
  {
    path: 'listalocales',
    loadChildren: () => import('./pages/listalocales/listalocales.module').then( m => m.ListalocalesPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'mapa',
    loadChildren: () => import('./pages/mapa/mapa.module').then( m => m.MapaPageModule)
  },
  {
    path: 'nuevavisita',
    loadChildren: () => import('./pages/nuevavisita/nuevavisita.module').then( m => m.NuevavisitaPageModule)
  },
  {
    path: 'nuevolocal',
    loadChildren: () => import('./pages/nuevolocal/nuevolocal.module').then( m => m.NuevolocalPageModule)
  },
  {
    path: 'nuevousuario',
    loadChildren: () => import('./pages/nuevousuario/nuevousuario.module').then( m => m.NuevousuarioPageModule)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then( m => m.TabsPageModule)
  },
  {
    path: 'usuariosfijos',
    loadChildren: () => import('./pages/usuariosfijos/usuariosfijos.module').then( m => m.UsuariosfijosPageModule)
  },
  {
    path: 'verimagenvisita',
    loadChildren: () => import('./pages/verimagenvisita/verimagenvisita.module').then( m => m.VerimagenvisitaPageModule)
  },
  {
    path: 'verlicencia',
    loadChildren: () => import('./pages/verlicencia/verlicencia.module').then( m => m.VerlicenciaPageModule)
  },
  {
    path: 'visitalocales',
    loadChildren: () => import('./pages/visitalocales/visitalocales.module').then( m => m.VisitalocalesPageModule)
  },
  {
    path: 'zonausuario',
    loadChildren: () => import('./pages/zonausuario/zonausuario.module').then( m => m.ZonausuarioPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'image-modal',
    loadChildren: () => import('./pages/image-modal/image-modal.module').then( m => m.ImageModalPageModule)
  },
  {
    path: 'cargarvisita',
    loadChildren: () => import('./pages/cargarvisita/cargarvisita.module').then( m => m.CargarvisitaPageModule)
  },
  {
    path: 'comprobante',
    loadChildren: () => import('./pages/comprobante/comprobante.module').then( m => m.ComprobantePageModule)
  },
  {
    path: 'movimientos',
    loadChildren: () => import('./pages/movimientos/movimientos.module').then( m => m.MovimientosPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
